import { FC, PropsWithChildren, useEffect, useMemo } from "react";
import { useSetRecoilState } from "recoil";

import { IPageContext, PageContext, useSchema } from "@ryde/redux";
import { pageEntityAtom, RydeUiUnit } from "@ryde/shared";

import { RidesSocketBridge } from "./rides-socket-bridge";

interface IPageContextWrapperProps extends PropsWithChildren {
  entity: RydeUiUnit;
  skipSchemaFetch?: boolean;
}

export const PageContextWrapper: FC<IPageContextWrapperProps> = ({
  children,
  entity,
  skipSchemaFetch = false,
}) => {
  const { fetchSchema } = useSchema(entity);
  const setRecoilEntity = useSetRecoilState(pageEntityAtom);

  useEffect(() => {
    setRecoilEntity(entity);
  }, [entity, setRecoilEntity]);

  useEffect(() => {
    if (!skipSchemaFetch) {
      fetchSchema();
    }
  }, [skipSchemaFetch, fetchSchema]);

  // Stable identity: a fresh literal here republished the context to every
  // usePageContext() consumer on each wrapper render.
  const contextData: IPageContext = useMemo(() => ({ entity }), [entity]);

  return (
    <>
      <RidesSocketBridge />
      <PageContext.Provider value={contextData}>
        {children}
      </PageContext.Provider>
    </>
  );
};
